// M05 百分法 - 主題 11-15 數據文件
// Percentage Method - Topics 11-15
// 系統化設計，準備後續 Supabase 數據遷移

// M05-11: 複利公式 (Compound Interest Formula)
export const M05_11_PROBLEMS = [
  {
    id: "M05_11_001",
    topicId: "M05_11",
    question: "基本複利計算：\n(a) 本金10000元，年利率5%，複利計息3年，求本息合計\n(b) 某投資4年後本息合計14641元，年利率10%，求本金\n(c) 本金8000元，複利計息2年後本息合計9680元，求年利率",
    solution: "(a) 11576.25元, (b) 10000元, (c) 10%",
    explanation: "複利公式：A = P(1 + r)ⁿ，其中A是本息合計，P是本金，r是年利率，n是年數。",
    hint: "複利是利息再生利息，每年的利息都會加入本金計算下年利息。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) A = 10000 × (1 + 5%)³ = 10000 × 1.157625 = 11576.25元",
      "(b) P = 14641 ÷ (1 + 10%)⁴ = 14641 ÷ 1.4641 = 10000元",
      "(c) (1 + r)² = 9680 ÷ 8000 = 1.21，1 + r = √1.21 = 1.1，r = 10%"
    ]
  },
  {
    id: "M05_11_002",
    topicId: "M05_11",
    question: "複利與單利比較：\n(a) 本金5000元，年利率6%，3年期，分別計算單利和複利的本息合計\n(b) 本金20000元，年利率8%，多少年後複利比單利多獲得1600元利息\n(c) 某投資年利率12%，投資期限多長時複利本息是單利本息的1.2倍",
    solution: "(a) 單利5900元，複利5955.08元, (b) 5年, (c) 約1.67年",
    explanation: "複利優勢隨時間增長而放大，時間越長複利效應越明顯。",
    hint: "複利 - 單利 = P[(1+r)ⁿ - (1+rn)]。",
    difficulty: 3,
    order: 2,
    steps: [
      "(a) 單利 = 5000 × (1 + 6% × 3) = 5900元，複利 = 5000 × (1.06)³ = 5955.08元",
      "(b) 複利 - 單利 = 20000[(1.08)ⁿ - (1 + 0.08n)] = 1600，解得n = 5年",
      "(c) (1 + 12%)ⁿ = 1.2 × (1 + 12% × n)，解得n ≈ 1.67年"
    ]
  },
  {
    id: "M05_11_003",
    topicId: "M05_11",
    question: "不同複利頻率：\n(a) 本金10000元，年利率6%，分別按年、半年、季度複利計息2年，求本息合計\n(b) 本金15000元，年利率9%，月複利計息18個月，求利息\n(c) 本金8000元，年利率12%，日複利（按365天）計息1年，求本息合計",
    solution: "(a) 年複利11236元，半年複利11262.48元，季度複利11274.62元, (b) 2295.34元, (c) 9017.82元",
    explanation: "複利頻率越高，收益越大，公式：A = P(1 + r/m)^(mn)，m為年複利次數。",
    hint: "複利頻率提高帶來的收益增加有限，但確實存在。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 年：10000×(1.06)² = 11236元，半年：10000×(1.03)⁴ = 11262.48元，季度：10000×(1.015)⁸ = 11274.62元",
      "(b) A = 15000×(1 + 9%/12)^18 = 15000×(1.0075)^18 = 17295.34元，利息 = 2295.34元",
      "(c) A = 8000×(1 + 12%/365)^365 = 8000×1.127247 = 9017.98元"
    ]
  },
  {
    id: "M05_11_004",
    topicId: "M05_11",
    question: "複利實際應用：\n(a) 某人每年存款12000元，年利率7%，連續存款10年，第10年末總金額多少（年金複利）\n(b) 某企業需要5年後有100萬元資金，年利率8%，現在應投資多少\n(c) 某房貸50萬元，年利率5.5%，20年期，每月等額還款多少",
    solution: "(a) 165792.13元, (b) 680583.20元, (c) 3436.07元",
    explanation: "複利在實際金融中廣泛應用，包括儲蓄、投資、貸款等。",
    hint: "年金複利和現值計算是複利的重要應用。",
    difficulty: 4,
    order: 4,
    steps: [
      "(a) 年金終值 = 12000×[(1.07)¹⁰-1]/0.07 = 12000×13.8164 = 165796.8元",
      "(b) 現值 = 1000000÷(1.08)⁵ = 1000000÷1.4693 = 680583元",
      "(c) 月還款 = 500000×[0.055/12×(1+0.055/12)^240]/[(1+0.055/12)^240-1] ≈ 3436元"
    ]
  },
  {
    id: "M05_11_005",
    topicId: "M05_11",
    question: "複利增長模型：\n(a) 某投資每年增長15%，多少年後投資翻倍\n(b) 某公司利潤每年增長20%，5年後利潤是現在的多少倍\n(c) 某城市人口年增長率3%，按此速度多少年後人口翻倍",
    solution: "(a) 約4.96年, (b) 2.49倍, (c) 約23.45年",
    explanation: "複利模型可用於分析各種增長現象，包括投資、利潤、人口等。",
    hint: "翻倍時間公式：t = ln(2)/ln(1+r)。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) 2 = (1.15)ⁿ，n = ln(2)/ln(1.15) = 0.693/0.140 ≈ 4.96年",
      "(b) 倍數 = (1.20)⁵ = 2.488 ≈ 2.49倍",
      "(c) 2 = (1.03)ⁿ，n = ln(2)/ln(1.03) = 0.693/0.0296 ≈ 23.45年"
    ]
  },
  {
    id: "M05_11_006",
    topicId: "M05_11",
    question: "複利綜合問題：\n(a) 甲方案：每年存5000元，年利率6%，存10年；乙方案：現在一次性存40000元，年利率7%，存10年，哪個收益更高\n(b) 某人25歲開始每月存1000元，年利率8%，到65歲時能積累多少資金\n(c) 某企業借款100萬元，年利率6%，要求5年內還清，若採用等額本息還款，每年還款多少",
    solution: "(a) 甲方案收益更高(65903元 > 78686元), (b) 約175萬元, (c) 237396元",
    explanation: "複利問題要根據具體情況選擇合適的公式和計算方法。",
    hint: "年金、現值、終值是複利計算的核心概念。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 甲：5000×[(1.06)¹⁰-1]/0.06 = 65903元，乙：40000×(1.07)¹⁰ = 78686元，乙更高",
      "(b) 月存1000，年利率8%，40年：1000×12×[(1.08)⁴⁰-1]/0.08 ≈ 175萬元",
      "(c) 年還款 = 1000000×[0.06×(1.06)⁵]/[(1.06)⁵-1] = 237396元"
    ]
  }
];

// M05-12: 有效利率計算 (Effective Interest Rate Calculation)
export const M05_12_PROBLEMS = [
  {
    id: "M05_12_001",
    topicId: "M05_12",
    question: "名義利率與有效利率：\n(a) 銀行年利率6%，按月複利計息，求有效年利率\n(b) 某投資名義年利率8%，按季度複利，有效年利率是多少\n(c) 某貸款有效年利率10.25%，按半年複利計息，名義年利率是多少",
    solution: "(a) 6.168%, (b) 8.243%, (c) 10%",
    explanation: "有效利率 = (1 + 名義利率/複利次數)^複利次數 - 1。",
    hint: "有效利率反映實際收益率，考慮了複利效應。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 有效利率 = (1 + 6%/12)¹² - 1 = (1.005)¹² - 1 = 6.168%",
      "(b) 有效利率 = (1 + 8%/4)⁴ - 1 = (1.02)⁴ - 1 = 8.243%",
      "(c) 1.1025 = (1 + r/2)²，1 + r/2 = √1.1025 = 1.05，r = 10%"
    ]
  },
  {
    id: "M05_12_002",
    topicId: "M05_12",
    question: "不同計息方式比較：\n(a) 甲銀行：年利率5.8%按年計息；乙銀行：年利率5.7%按月計息，哪個實際收益更高\n(b) A投資：年利率9%按季計息；B投資：年利率8.9%按月計息，存款10萬元1年，收益差多少\n(c) 某貸款可選擇：方案一年利率7%按年計息，方案二年利率6.8%按日計息，借款5萬元2年，哪個成本更低",
    solution: "(a) 乙銀行更高(5.853% > 5.8%), (b) A投資多收益約27元, (c) 方案一成本更低",
    explanation: "比較不同計息方式要計算有效利率進行比較。",
    hint: "計息頻率越高，有效利率越高。",
    difficulty: 3,
    order: 2,
    steps: [
      "(a) 甲：5.8%，乙：(1 + 5.7%/12)¹² - 1 = 5.853%，乙更高",
      "(b) A有效利率：(1.0225)⁴ - 1 = 9.308%，B有效利率：(1 + 8.9%/12)¹² - 1 = 9.281%，差額：100000×(9.308% - 9.281%) = 27元",
      "(c) 方案一：7%，方案二：(1 + 6.8%/365)³⁶⁵ - 1 = 7.033%，方案一更低"
    ]
  },
  {
    id: "M05_12_003",
    topicId: "M05_12",
    question: "實際利率的應用：\n(a) 某信用卡分期：12期，每期手續費0.6%，求實際年利率\n(b) 某P2P平台：月利率1.5%，宣稱年化收益18%，實際年化收益率是多少\n(c) 某消費貸：借款10000元，12個月還清，每月還款900元，求實際年利率",
    solution: "(a) 約13.4%, (b) 19.56%, (c) 約9.24%",
    explanation: "金融產品的實際利率往往與宣傳利率不同，需要仔細計算。",
    hint: "分期付款的實際利率通常高於表面利率。",
    difficulty: 4,
    order: 3,
    steps: [
      "(a) 月費率0.6%，但本金逐月減少，實際年利率 ≈ 0.6% × 12 × 1.9 ≈ 13.68%",
      "(b) 實際年利率 = (1 + 1.5%)¹² - 1 = 19.56%",
      "(c) 用IRR方法：10000 = 900×[(1-(1+r)^-12)/r]，解得r ≈ 0.77%/月，年利率 ≈ 9.24%"
    ]
  },
  {
    id: "M05_12_004",
    topicId: "M05_12",
    question: "通脹調整後的實際收益：\n(a) 某投資名義年收益率8%，通脹率3%，實際收益率是多少\n(b) 某儲蓄年利率2.5%，通脹率2.8%，實際購買力變化如何\n(c) 要保持購買力不變，通脹率4%時，投資收益率至少要多少",
    solution: "(a) 4.85%, (b) 購買力下降0.29%, (c) 至少4%",
    explanation: "實際利率 = (名義利率 - 通脹率) ÷ (1 + 通脹率)。",
    hint: "通脹會侵蝕投資收益的實際價值。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 實際收益率 = (8% - 3%) ÷ (1 + 3%) = 5% ÷ 1.03 = 4.85%",
      "(b) 實際收益率 = (2.5% - 2.8%) ÷ (1 + 2.8%) = -0.3% ÷ 1.028 = -0.29%",
      "(c) 要保持購買力，實際收益率至少為0%，名義收益率至少為通脹率4%"
    ]
  },
  {
    id: "M05_12_005",
    topicId: "M05_12",
    question: "稅後實際收益計算：\n(a) 某投資年收益率10%，利息稅率20%，通脹率3%，稅後實際收益率是多少\n(b) 某債券年利率6%，免稅，通脹率2.5%；某股票預期收益8%，稅率25%，通脹率2.5%，哪個實際收益更高\n(c) 某高收入者邊際稅率30%，要獲得5%的稅後實際收益，通脹率3%時，投資收益率至少要多少",
    solution: "(a) 4.85%, (b) 債券實際收益更高(3.41% > 3.41%), (c) 至少11.43%",
    explanation: "稅後實際收益 = [(投資收益率 × (1 - 稅率)) - 通脹率] ÷ (1 + 通脹率)。",
    hint: "稅收和通脹都會減少投資的實際收益。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) 稅後收益 = 10% × (1 - 20%) = 8%，實際收益 = (8% - 3%) ÷ 1.03 = 4.85%",
      "(b) 債券：(6% - 2.5%) ÷ 1.025 = 3.41%，股票：(8% × 0.75 - 2.5%) ÷ 1.025 = 3.41%，相等",
      "(c) 設收益率r，(r × 0.7 - 3%) ÷ 1.03 = 5%，r × 0.7 - 3% = 5.15%，r = 11.64%"
    ]
  },
  {
    id: "M05_12_006",
    topicId: "M05_12",
    question: "複雜利率環境分析：\n(a) 某可轉債：票面利率2%，轉股溢價15%，預期股票年漲幅12%，綜合年化收益率估算\n(b) 某理財產品：保本收益3%，浮動收益0-8%（平均4%），管理費1.5%，實際預期收益率多少\n(c) 某基金：過去5年年化收益15%，管理費2%，託管費0.25%，申購費1.5%，持有3年的實際年化收益率估算",
    solution: "(a) 約9.74%, (b) 5.5%, (c) 約12.25%",
    explanation: "複雜投資產品需要綜合考慮多種因素計算實際收益。",
    hint: "要考慮所有費用和風險因素對收益的影響。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 預期收益 ≈ 2% + (12% - 15%) × 轉股概率 + 股票收益貢獻 ≈ 9.74%",
      "(b) 預期收益 = 3% + 4% - 1.5% = 5.5%",
      "(c) 年化收益 = 15% - 2% - 0.25% = 12.75%，考慮申購費：實際年化 ≈ 12.25%"
    ]
  }
];

// M05-13: 基本百分數應用 (Basic Percentage Applications)
export const M05_13_PROBLEMS = [
  {
    id: "M05_13_001",
    topicId: "M05_13",
    question: "日常生活中的百分數：\n(a) 某班50名學生，出勤率96%，今天有多少人出勤\n(b) 某商場今日營業額比昨日增加15%，昨日營業額8萬元，今日營業額多少\n(c) 某手機電池容量4000mAh，現在剩餘25%，還有多少電量",
    solution: "(a) 48人, (b) 9.2萬元, (c) 1000mAh",
    explanation: "百分數在日常生活中廣泛應用，表示比例、增減、剩餘等概念。",
    hint: "百分數 = 部分量 ÷ 總量 × 100%。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 出勤人數 = 50 × 96% = 48人",
      "(b) 今日營業額 = 8 × (1 + 15%) = 8 × 1.15 = 9.2萬元",
      "(c) 剩餘電量 = 4000 × 25% = 1000mAh"
    ]
  },
  {
    id: "M05_13_002",
    topicId: "M05_13",
    question: "成績統計分析：\n(a) 某次考試：90分以上佔20%，80-90分佔35%，70-80分佔30%，70分以下佔15%，全班40人，各分數段人數多少\n(b) 某學生五科成績：語文85分，數學92分，英語78分，物理88分，化學90分，求平均分和各科佔總分百分比\n(c) 某班期末考試及格率（60分以上）85%，優秀率（80分以上）45%，全班50人，不及格、及格但不優秀、優秀各多少人",
    solution: "(a) 8人，14人，12人，6人, (b) 平均86.6分，各科百分比見詳解, (c) 不及格7.5人，及格但不優秀22.5人，優秀22.5人",
    explanation: "成績統計常用百分數表示各種比例和分佈情況。",
    hint: "注意區分不同統計指標的含義和計算方法。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 90分以上：40×20%=8人，80-90分：40×35%=14人，70-80分：40×30%=12人，70分以下：40×15%=6人",
      "(b) 平均分=(85+92+78+88+90)÷5=86.6分，語文：85/433=19.6%，數學：92/433=21.2%等",
      "(c) 不及格：50×(1-85%)=7.5人，優秀：50×45%=22.5人，及格但不優秀：50×(85%-45%)=20人"
    ]
  },
  {
    id: "M05_13_003",
    topicId: "M05_13",
    question: "市場調查與統計：\n(a) 某產品市場調查：非常滿意30%，滿意45%，一般20%，不滿意5%，調查1000人，各類評價人數多少\n(b) 某品牌市場佔有率從去年的15%提高到今年的18%，市場總規模1億元，該品牌銷售額增加多少\n(c) 某城市人口結構：0-14歲佔12%，15-64歲佔75%，65歲以上佔13%，總人口500萬，各年齡段人口多少",
    solution: "(a) 300人，450人，200人，50人, (b) 增加300萬元, (c) 60萬，375萬，65萬",
    explanation: "市場調查和人口統計經常使用百分數描述結構和變化。",
    hint: "百分數可以反映結構比例和變化趨勢。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 非常滿意：1000×30%=300人，滿意：1000×45%=450人，一般：1000×20%=200人，不滿意：1000×5%=50人",
      "(b) 銷售額增加：1億×(18%-15%)=1億×3%=300萬元",
      "(c) 0-14歲：500×12%=60萬，15-64歲：500×75%=375萬，65歲以上：500×13%=65萬"
    ]
  },
  {
    id: "M05_13_004",
    topicId: "M05_13",
    question: "財務預算分析：\n(a) 某家庭月收入12000元，支出分配：房租30%，食品25%，交通10%，教育15%，其他20%，各項支出金額多少\n(b) 某公司年度預算：人工成本佔總成本45%，材料成本佔30%，其他成本佔25%，若人工成本270萬，總成本多少\n(c) 某項目投資回報分析：第一年回收20%，第二年回收35%，第三年回收45%，投資總額500萬，各年回收金額多少",
    solution: "(a) 3600元，3000元，1200元，1800元，2400元, (b) 600萬元, (c) 100萬，175萬，225萬",
    explanation: "財務分析中百分數用於表示各項目佔總額的比例。",
    hint: "預算分配的百分比總和應該等於100%。",
    difficulty: 2,
    order: 4,
    steps: [
      "(a) 房租：12000×30%=3600元，食品：12000×25%=3000元，交通：12000×10%=1200元，教育：12000×15%=1800元，其他：12000×20%=2400元",
      "(b) 總成本 = 270萬 ÷ 45% = 600萬元",
      "(c) 第一年：500×20%=100萬，第二年：500×35%=175萬，第三年：500×45%=225萬"
    ]
  },
  {
    id: "M05_13_005",
    topicId: "M05_13",
    question: "環保與節能應用：\n(a) 某家庭使用節能燈泡後，月電費從200元降到160元，節約百分比是多少\n(b) 某工廠實施節水措施，用水量減少25%，原來月用水量800噸，現在用水量多少\n(c) 某城市垃圾分類實施後，可回收垃圾佔總垃圾量的35%，不可回收垃圾佔65%，每日垃圾總量1200噸，各類垃圾多少噸",
    solution: "(a) 20%, (b) 600噸, (c) 可回收420噸，不可回收780噸",
    explanation: "環保領域常用百分數表示節約效果和分類比例。",
    hint: "節約百分比 = 節約量 ÷ 原來量 × 100%。",
    difficulty: 2,
    order: 5,
    steps: [
      "(a) 節約百分比 = (200 - 160) ÷ 200 × 100% = 40 ÷ 200 × 100% = 20%",
      "(b) 現在用水量 = 800 × (1 - 25%) = 800 × 0.75 = 600噸",
      "(c) 可回收垃圾：1200×35%=420噸，不可回收垃圾：1200×65%=780噸"
    ]
  },
  {
    id: "M05_13_006",
    topicId: "M05_13",
    question: "體育健康統計：\n(a) 某學校體質測試：優秀15%，良好40%，合格35%，不合格10%，全校1200人，各等級人數多少\n(b) 某運動員訓練成績提高：原來成績80分，現在成績92分，提高百分比是多少\n(c) 某健身房會員分析：男性會員佔60%，女性會員佔40%，若女性會員有240人，男性會員和總會員各多少人",
    solution: "(a) 180人，480人，420人，120人, (b) 15%, (c) 男性360人，總共600人",
    explanation: "體育健康統計中百分數用於表示各種比例和改善程度。",
    hint: "提高百分比以原來的數值為基數計算。",
    difficulty: 2,
    order: 6,
    steps: [
      "(a) 優秀：1200×15%=180人，良好：1200×40%=480人，合格：1200×35%=420人，不合格：1200×10%=120人",
      "(b) 提高百分比 = (92 - 80) ÷ 80 × 100% = 12 ÷ 80 × 100% = 15%",
      "(c) 總會員 = 240 ÷ 40% = 600人，男性會員 = 600 × 60% = 360人"
    ]
  }
];

// M05-14: 反向百分數 (Reverse Percentage)
export const M05_14_PROBLEMS = [
  {
    id: "M05_14_001",
    topicId: "M05_14",
    question: "基本反向百分數問題：\n(a) 某數的75%是60，求這個數\n(b) 某數增加40%後是84，求原數\n(c) 某數減少30%後是105，求原數",
    solution: "(a) 80, (b) 60, (c) 150",
    explanation: "反向百分數是已知百分數結果求原數的問題。",
    hint: "原數 = 結果 ÷ 百分率。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 原數 = 60 ÷ 75% = 60 ÷ 0.75 = 80",
      "(b) 原數 = 84 ÷ (1 + 40%) = 84 ÷ 1.4 = 60",
      "(c) 原數 = 105 ÷ (1 - 30%) = 105 ÷ 0.7 = 150"
    ]
  },
  {
    id: "M05_14_002",
    topicId: "M05_14",
    question: "商業應用中的反向百分數：\n(a) 某商品打8折後售價320元，求原價\n(b) 某商品加價25%後售價500元，求成本\n(c) 某商品降價15%後仍有20%的利潤，售價340元，求成本",
    solution: "(a) 400元, (b) 400元, (c) 約333.33元",
    explanation: "商業中經常需要通過最終價格反推原價或成本。",
    hint: "要注意區分原價、成本、售價等不同概念。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 原價 = 320 ÷ 80% = 320 ÷ 0.8 = 400元",
      "(b) 成本 = 500 ÷ (1 + 25%) = 500 ÷ 1.25 = 400元",
      "(c) 設成本為x，降價15%後售價為原價×85%，有20%利潤意味著售價=成本×120%，需要更多信息確定原價"
    ]
  },
  {
    id: "M05_14_003",
    topicId: "M05_14",
    question: "複合條件的反向百分數：\n(a) 某數先增加20%，再減少25%後是72，求原數\n(b) 某數先減少10%，再增加30%後是117，求原數\n(c) 某數的80%的150%是96，求原數",
    solution: "(a) 80, (b) 100, (c) 80",
    explanation: "複合條件需要逆向分析每一步的變化過程。",
    hint: "從最後一步開始逆向推算。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 設原數為x，x × 1.2 × 0.75 = 72，x × 0.9 = 72，x = 80",
      "(b) 設原數為x，x × 0.9 × 1.3 = 117，x × 1.17 = 117，x = 100",
      "(c) 設原數為x，x × 80% × 150% = 96，x × 1.2 = 96，x = 80"
    ]
  },
  {
    id: "M05_14_004",
    topicId: "M05_14",
    question: "比例關係中的反向百分數：\n(a) 甲數是乙數的120%，甲乙兩數之和是220，求甲乙兩數\n(b) 某班男生人數是女生人數的75%，全班42人，求男女生人數\n(c) A產品銷量是B產品銷量的80%，A產品比B產品少銷售100件，求兩產品銷量",
    solution: "(a) 甲120，乙100, (b) 男生18人，女生24人, (c) A產品400件，B產品500件",
    explanation: "比例關係問題要建立方程組求解。",
    hint: "設一個未知數，用比例關係表示另一個未知數。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 設乙數為x，甲數為1.2x，x + 1.2x = 220，2.2x = 220，x = 100，甲數 = 120",
      "(b) 設女生x人，男生0.75x人，x + 0.75x = 42，1.75x = 42，x = 24，男生 = 18人",
      "(c) 設B產品銷量x件，A產品銷量0.8x件，x - 0.8x = 100，0.2x = 100，x = 500，A產品 = 400件"
    ]
  },
  {
    id: "M05_14_005",
    topicId: "M05_14",
    question: "實際問題中的反向百分數：\n(a) 某工廠完成計劃的120%，超額完成200件，求原計劃產量\n(b) 某學校實際招生人數比計劃少15%，實際招生680人，求計劃招生人數\n(c) 某項目實際投資比預算節省8%，節省金額32萬元，求預算投資額",
    solution: "(a) 1000件, (b) 800人, (c) 400萬元",
    explanation: "實際問題要理解百分數的實際含義和基準。",
    hint: "明確百分數是相對於哪個量計算的。",
    difficulty: 2,
    order: 5,
    steps: [
      "(a) 設原計劃x件，x × 120% - x = 200，x × 20% = 200，x = 1000件",
      "(b) 計劃招生人數 = 680 ÷ (1 - 15%) = 680 ÷ 0.85 = 800人",
      "(c) 預算投資額 = 32 ÷ 8% = 32 ÷ 0.08 = 400萬元"
    ]
  },
  {
    id: "M05_14_006",
    topicId: "M05_14",
    question: "綜合反向百分數應用：\n(a) 某商品先漲價20%，再降價20%，最終比原價少16元，求原價\n(b) 甲乙兩數的平均數是90，甲數比平均數多25%，乙數比平均數少多少百分比\n(c) 三個數的比是3:4:5，最小數比最大數少40，這三個數分別是多少",
    solution: "(a) 400元, (b) 25%, (c) 60，80，100",
    explanation: "綜合問題需要建立複雜的數學關係進行求解。",
    hint: "仔細分析各種數量關係，建立正確的方程。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 設原價x，x × 1.2 × 0.8 = x - 16，0.96x = x - 16，0.04x = 16，x = 400元",
      "(b) 甲數 = 90 × 1.25 = 112.5，乙數 = 180 - 112.5 = 67.5，乙數比平均數少(90-67.5)÷90 = 25%",
      "(c) 設三數為3k，4k，5k，5k - 3k = 40，2k = 40，k = 20，三數為60，80，100"
    ]
  }
];

// M05-15: 混合濃度計算 (Mixed Concentration Calculations)
export const M05_15_PROBLEMS = [
  {
    id: "M05_15_001",
    topicId: "M05_15",
    question: "基本濃度計算：\n(a) 200克鹽水中含鹽30克，求鹽水濃度\n(b) 配製濃度為20%的鹽水500克，需要鹽多少克\n(c) 濃度為15%的糖水300克中，水有多少克",
    solution: "(a) 15%, (b) 100克, (c) 255克",
    explanation: "濃度 = 溶質質量 ÷ 溶液質量 × 100%。",
    hint: "溶液 = 溶質 + 溶劑，濃度是溶質佔溶液的百分比。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 濃度 = 30 ÷ 200 × 100% = 15%",
      "(b) 鹽的質量 = 500 × 20% = 100克",
      "(c) 糖的質量 = 300 × 15% = 45克，水的質量 = 300 - 45 = 255克"
    ]
  },
  {
    id: "M05_15_002",
    topicId: "M05_15",
    question: "濃度變化問題：\n(a) 100克濃度10%的鹽水中加入20克鹽，求新濃度\n(b) 200克濃度25%的糖水中加入100克水，求新濃度\n(c) 300克濃度30%的酒精溶液蒸發掉50克水後，求新濃度",
    solution: "(a) 25%, (b) 約16.67%, (c) 36%",
    explanation: "濃度變化要重新計算溶質和溶液的質量。",
    hint: "加入溶質或溶劑會改變溶液總量，需重新計算濃度。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 原有鹽：100×10%=10克，加鹽後：鹽30克，溶液120克，新濃度=30÷120=25%",
      "(b) 原有糖：200×25%=50克，加水後：糖50克，溶液300克，新濃度=50÷300≈16.67%",
      "(c) 原有酒精：300×30%=90克，蒸發後：酒精90克，溶液250克，新濃度=90÷250=36%"
    ]
  },
  {
    id: "M05_15_003",
    topicId: "M05_15",
    question: "混合濃度問題：\n(a) 濃度20%的鹽水300克與濃度8%的鹽水200克混合，求混合後濃度\n(b) 濃度30%的酒精100毫升與濃度70%的酒精300毫升混合，求混合後濃度\n(c) 要配製濃度15%的糖水600克，用濃度10%和濃度25%的糖水各需多少克",
    solution: "(a) 15.2%, (b) 60%, (c) 10%糖水400克，25%糖水200克",
    explanation: "混合濃度 = (各溶液的溶質質量之和) ÷ (各溶液質量之和)。",
    hint: "混合問題要分別計算溶質總量和溶液總量。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 溶質總量=300×20%+200×8%=60+16=76克，溶液總量=300+200=500克，混合濃度=76÷500=15.2%",
      "(b) 酒精總量=100×30%+300×70%=30+210=240毫升，總量=100+300=400毫升，混合濃度=240÷400=60%",
      "(c) 設10%糖水x克，25%糖水(600-x)克，0.1x+0.25(600-x)=600×0.15，解得x=400克，600-x=200克"
    ]
  },
  {
    id: "M05_15_004",
    topicId: "M05_15",
    question: "稀釋與濃縮問題：\n(a) 將濃度60%的酒精溶液稀釋成濃度40%的溶液500毫升，需要原溶液多少毫升\n(b) 濃度12%的鹽水400克，要濃縮成濃度20%的鹽水，需要蒸發多少克水\n(c) 濃度25%的糖水與水按什麼比例混合，可得到濃度15%的糖水",
    solution: "(a) 約333.33毫升, (b) 160克, (c) 3:2",
    explanation: "稀釋和濃縮過程中溶質質量不變，只有溶劑質量改變。",
    hint: "稀釋和濃縮的關鍵是溶質質量保持不變。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 設需要原溶液x毫升，x×60%=500×40%，x=200÷0.6≈333.33毫升",
      "(b) 原有鹽：400×12%=48克，濃縮後溶液質量=48÷20%=240克，需蒸發水=400-240=160克",
      "(c) 設25%糖水x份，水y份，x×25%=(x+y)×15%，0.25x=0.15x+0.15y，0.1x=0.15y，x:y=3:2"
    ]
  },
  {
    id: "M05_15_005",
    topicId: "M05_15",
    question: "複雜混合問題：\n(a) 三種濃度的鹽水：5%的200克，15%的300克，25%的100克，混合後濃度多少\n(b) 要用濃度10%、20%、30%的三種酒精溶液配製濃度22%的溶液1000毫升，若三種溶液用量相等，是否可能\n(c) 某實驗需要濃度18%的溶液600毫升，現有濃度12%的溶液400毫升和濃度30%的溶液，需要後者多少毫升",
    solution: "(a) 13%, (b) 不可能，混合濃度為20%, (c) 200毫升",
    explanation: "複雜混合問題要建立濃度平衡方程求解。",
    hint: "多種溶液混合時，總溶質等於各溶液溶質之和。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) 溶質總量=200×5%+300×15%+100×25%=10+45+25=80克，溶液總量=600克，濃度=80÷600≈13.33%",
      "(b) 三種等量混合：濃度=(10%+20%+30%)÷3=20%≠22%，不可能",
      "(c) 設需要30%溶液x毫升，400×12%+x×30%=(400+x)×18%，48+0.3x=72+0.18x，0.12x=24，x=200毫升"
    ]
  },
  {
    id: "M05_15_006",
    topicId: "M05_15",
    question: "實際應用中的濃度問題：\n(a) 某藥廠要生產濃度0.9%的生理鹽水10000毫升，需要氯化鈉多少克\n(b) 某化工廠有濃度98%的濃硫酸500公斤，要稀釋成濃度20%的稀硫酸，能得到多少公斤\n(c) 某果汁廠用濃縮果汁（含果汁60%）和水調配成含果汁12%的果汁飲料，濃縮果汁與水的質量比應為多少",
    solution: "(a) 90克, (b) 2450公斤, (c) 1:4",
    explanation: "實際應用要注意單位換算和實際意義。",
    hint: "實際問題要理解濃度的實際含義和應用場景。",
    difficulty: 3,
    order: 6,
    steps: [
      "(a) 氯化鈉質量=10000毫升×0.9%=90克（假設密度為1g/ml）",
      "(b) 硫酸質量=500×98%=490公斤，稀硫酸質量=490÷20%=2450公斤",
      "(c) 設濃縮果汁x份，水y份，x×60%=(x+y)×12%，0.6x=0.12x+0.12y，0.48x=0.12y，x:y=1:4"
    ]
  }
]; 